import { TextField, Typography } from '@mui/material'

// import LoadingButton from 'components/molecules/LoadingButton/LoadingButton'
import LoadingButton from '@mui/lab/LoadingButton'
import useRepApprovalLogic from './RepApproval.logic'
import { RepApprovalProps } from './RepApproval.types'

const RepApproval = (props: RepApprovalProps) => {
  const {
    isRep,
    isGuest,
    isNurseUser,
    disableSubmit,
    procedureStatus,
    repInfoHelperText,
    repApprovalFormData,
    repApprovalFormErrors,
    handleSubmit,
    handleValidateForm,
    handleChangeFormData,
    FormValidationAlertToasters,
  } = useRepApprovalLogic(props)
  const { setAssetStatusMutation } = props

  return (
    <>
      {FormValidationAlertToasters()}

      <form onSubmit={handleSubmit}>
        {(isNurseUser || isRep) && !isGuest && (
          <TextField
            id="repName"
            name="repName"
            label={
              isNurseUser
                ? 'Type your name to approve'
                : 'Name of approving sales rep'
            }
            disabled={procedureStatus !== 'PRE_APPROVAL'}
            value={repApprovalFormData.repName ?? ''}
            onChange={handleChangeFormData}
            // Show initial error only onBlur but once input is touched validate on input change
            error={
              repApprovalFormData.repName?.length !== 0 ||
              !repApprovalFormErrors.repName
                ? false
                : true
            }
            onBlur={handleValidateForm}
            required
            size="small"
            fullWidth
            variant="standard"
            helperText="Your first and last name are required to approve the products"
            sx={{ my: 2 }}
          />
        )}
        {isNurseUser && (
          <>
            <TextField
              id="note"
              name="note"
              label="Note"
              disabled={procedureStatus !== 'PRE_APPROVAL'}
              value={repApprovalFormData?.note || ''}
              onChange={handleChangeFormData}
              size="small"
              fullWidth
              variant="standard"
              sx={{ mb: 2 }}
            />
          </>
        )}
        {(isNurseUser || isGuest) && (
          <>
            {isGuest && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                As a guest rep, please provide your contact information below
              </Typography>
            )}
            <TextField
              id="repInfo"
              name="repInfo"
              label="RN Name / Surgeon Name / Hospital"
              disabled={procedureStatus !== 'PRE_APPROVAL'}
              value={repApprovalFormData?.repInfo || ''}
              onChange={handleChangeFormData}
              size="small"
              fullWidth
              variant="standard"
              sx={{ mb: 2 }}
              error={!!repApprovalFormErrors.repInfo}
              helperText={repInfoHelperText}
              required={isGuest}
            />
          </>
        )}

        <LoadingButton
          data-testid="approve-assets-button"
          type="submit"
          disabled={disableSubmit}
          loading={setAssetStatusMutation.loading}
          sx={{ mb: 1.5 }}
          variant="contained"
          fullWidth
          color="primary"
        >
          Approve products
        </LoadingButton>
      </form>
    </>
  )
}

export default RepApproval
